const autocompleteModalDocCompany = {
  documentTypes: 'Tipo de Documento',
  document: 'Documento',
};

export default autocompleteModalDocCompany;
